<template>
  <div
    class="upload-container"
  >
    <div
      class="upload-wrapper"
      :class="{ 'is-dragging': isDragging, 'is-select-error': Boolean(selectError), 'isDisabled': Boolean(file) }"
      @drop.prevent="onDrop"
      @dragover.prevent="onDragOver"
      @dragleave="onDragLeave"
    >
      <div
        v-if="!isDragging && !Boolean(selectError)"
        class="d-flex flex-column align-items-center"
      >
        <div class="upload-icon">
          <img
            :src="imageSquare"
            alt="Image icon"
          >
        </div>
        <div class="upload-text">
          <span>Drop your file(s) here or &nbsp;</span>
          <span
            class="browse-text"
            :class="{ 'disabled': Boolean(file) }"
            @click="handleBrowseImage"
          >
            Browse
          </span>
        </div>
        <div class="upload-sub-text">
          <span>Max 10 MB files are allowed</span>
        </div>
      </div>
      <div v-else-if="Boolean(selectError)">
        <p class="error-text">
          {{ selectError }}
        </p>
      </div>
      <div v-else>
        <p class="drag-text">
          Drop file to upload
        </p>
      </div>
    </div>
    <p
      v-if="!isSuccess"
      class="upload-sub-text"
    >
      Accepts .gif .jpg and .png
    </p>
    <input
      ref="logoFile"
      hidden
      type="file"
      accept="image/png, image/jpeg, image/gif, image/jpg"
      @change="onSelectImage"
    >
  </div>
</template>
<script>
import analytics from '@/@core/utils/analytics'
import imageSquare from '@/assets/images/icons/image-square.svg'
import constants from '@/constants'
import { getFileSize } from '@/utils/fileUtils'

export default {
  name: 'DragAndDrop',
  props: {
    selectError: {
      type: String,
      default: '',
    },
    isSuccess: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'logo',
    },
    file: {
      type: File,
      default: null,
    },
  },
  data() {
    return {
      imageSquare,
      isDragging: false,
    }
  },
  methods: {
    handleBrowseImage() {
      if (this.file) return
      analytics.track(constants.TRACKS.ACTIONS.REGISTER_V2.UPLOAD_COMPANY_IMAGE_CLICK_BROWSE_LINK, {
        pageName: `Upload your company ${this.type}`,
      })
      this.$refs.logoFile.click()
    },
    trackSelectImage(file, type) {
      const eventName = type === 'drop'
        ? constants.TRACKS.ACTIONS.REGISTER_V2.UPLOAD_COMPANY_IMAGE_DROP_IMAGE
        : constants.TRACKS.ACTIONS.REGISTER_V2.UPLOAD_COMPANY_IMAGE_SELECT_IMAGE
      analytics.track(eventName, {
        pageName: `Upload your company ${this.type}`,
        fileName: file.name,
        fileSize: getFileSize(file.size),
        fileType: file.type,
      })
    },
    onDrop(event) {
      this.file = event.dataTransfer.files[0]
      this.trackSelectImage(event.dataTransfer.files[0], 'drop')
      this.$emit('select-image', event.dataTransfer.files)
      this.isDragging = false
    },
    onDragOver() {
      this.isDragging = true
    },
    onDragLeave() {
      this.isDragging = false
    },
    onSelectImage(event) {
      this.trackSelectImage(event.target.files[0], 'select')
      this.$emit('select-image', event.target.files)
    },
  },
}
</script>
<style lang="scss" scoped>
.upload-container {
  width: 100%;
}
.upload-wrapper {
  display: flex;
  padding: 32px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px dashed #C9CDD2;
  background: #FFF;
  height: 156px;
  justify-content: center;
}

.upload-wrapper.isDisabled {
  cursor: not-allowed;
  border-color: #E0E3E6;
  background-color: #F7F7F8;
  color: #94979E;
  margin-bottom: 20px;

  .upload-sub-text {
    color: #94979E;
  }

  .browse-text {
    color: #94979E;
  }
}

.upload-icon {
  display: flex;
  padding: 8px;
  width: fit-content;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: #F7F7F8;
}
.is-dragging {
  border-color: #0368A0;
  background-color: #EFF8FE;
}

.is-select-error {
  border-color: #F86F6E;
  background-color: #FEF1F1;
}

.error-text {
  color: #B51D1D;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0;
}

.drag-text {
  color: #0368A0;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0;
}
.upload-text {
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.browse-text {
  color: #0368A0;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  &.disabled {
    cursor: not-allowed;
  }
  &.disabled:hover {
    text-decoration: none;
  }
}
.upload-sub-text {
  margin-top: 8px;
  color: #61646B;
  font-size: 12px;
  line-height: 16px;
}
</style>
